export enum IStackDetailsPageTabs {
  Overview = 'overview',
  Resources = 'resources',
}

export enum IAppsDetailsPageTabs {
  Myapps = 'myapps',
  Allapps = 'allapps',
  Templates = 'templates',
  Approvals = 'approvals',
}
